import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { proposalApi } from '@modules/proposals/api';
import queryClient from '@app/queryClient';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { UpdateProposalRequestDto } from '@modules/proposals/api/dto/updateProposal.dto';

const useUpdateProposal = (externalId: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['updateProposal'],
    mutationFn: (body: UpdateProposalRequestDto) =>
      proposalApi.updateProposal(externalId, body),
    onMutate: () => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_ATTEMPTED, {
        useContext: true,
        addToContext: true,
        proposal_id: externalId,
      });
    },
    onSuccess: async () => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_COMPLETED, { useContext: true });
      await queryClient.refetchQueries({ queryKey: ['proposal', externalId] });
      queryClient.invalidateQueries({ queryKey: ['proposalPreview', externalId] });
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_FAILED, {
        useContext: true,
        error_message: e.message,
      });
      toast('error', { message: e.message });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useUpdateProposal;
